import { Avatar, SxProps, Theme, Tooltip } from "@mui/material";
import { GREEN } from "@/config/mui/colorPalette";
import { getAvatarColor, getUserCalendarColor } from "@/utils";

type Props = {
  initials: {
    firstName: string;
    lastName: string;
    id?: string;
    userIndex?: number;
  };
  size?: number;
  sx?: SxProps<Theme>;
};

function InitialsAvatar({ initials, size = 48, sx = {} }: Props) {
  const { firstName, lastName } = initials;

  const userColorPalette =
    initials.userIndex !== undefined &&
    getUserCalendarColor(initials).colorObjectByIndex;

  const textColor = userColorPalette ? userColorPalette[100] : GREEN[100];

  const backgroundColor = userColorPalette
    ? userColorPalette[60]
    : getAvatarColor(initials);

  return (
    <Tooltip title={`${firstName} ${lastName}`} arrow>
      <Avatar
        alt={`${firstName} ${lastName}`}
        sx={{
          width: size,
          height: size,
          color: textColor,
          typography: "subtitleSmall",
          background: backgroundColor,
          ...sx,
        }}
      >
        {firstName[0]}
        {lastName[0]}
      </Avatar>
    </Tooltip>
  );
}

export default InitialsAvatar;
